import {RoleMasterForm} from "../../../models/config/RoleMaster";
import {useCompanyMaster} from "../../../queries";
import {useCallback, useMemo} from "react";
import {useMenuMaster} from "../../LegacyMenuMasterConfig/queries";
import {MenuMaster} from "../../../models/config/MenuMaster";
import {twMerge} from "tailwind-merge";
import {Button, Table} from "react-bootstrap";
import {FaEdit, FaTimesCircle} from "react-icons/fa";
import Select from 'react-select';

export type RoleMasterTableProps = {
    roleMasterForms?: RoleMasterForm[];
    isPending?: boolean;
    className?: string;
    onEdit?: (roleMasterForm: RoleMasterForm) => void;
    onDelete?: (roleMasterForm: RoleMasterForm) => void;
};

export const RoleMasterTable = (props: RoleMasterTableProps) => {
    const { isPending, roleMasterForms, className, onEdit, onDelete } = props;
    
    const { data: companyMaster } = useCompanyMaster();
    const companyMasterMap = useMemo(
        () => new Map(companyMaster?.map(company => [company.sid, company])),
        [companyMaster]
    );
    
    const { data: menuMaster = [] } = useMenuMaster();

    const getMenuMasterLabel = useCallback(
        (menuMaster: MenuMaster) => `${menuMaster.id}: ${menuMaster.menu_name}`,
        []
    );

    const getMenuMasterValue = useCallback(
        (menuMaster: MenuMaster) => menuMaster.id,
        []
    );

    return (
        <div className={twMerge('tw-flex-1', className)}>
            <Table
                size="sm"
                className="table-bordered table-auto align-middle"
            >
                <thead>
                <tr>
                    <th />
                    <th>Company Name</th>
                    <th>Role ID</th>
                    <th>Permissions</th>
                </tr>
                </thead>
                <tbody>
                {isPending ? (
                    <tr>
                        <td colSpan={99}>
                            <div className="tw-flex tw-items-center tw-justify-center">
                                <div className="spinner-border text-primary tw-my-2"/>
                            </div>
                        </td>
                    </tr>
                ) : (
                    roleMasterForms?.map((roleMasterForm, index) => (
                        <tr key={index}>
                            <td className="tw-whitespace-nowrap align-middle">
                            <Button
                                    size="sm"
                                    variant="outline-info"
                                    onClick={() => onEdit?.(roleMasterForm)}
                                >
                                    <FaEdit />
                                </Button>
                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    className="tw-ml-1"
                                    onClick={() =>
                                        onDelete?.(roleMasterForm)
                                    }
                                >
                                    <FaTimesCircle />
                                </Button>
                            </td>
                            <td className="tw-text-center align-middle">
                            {roleMasterForm.sid === '*'
                                    ? roleMasterForm.sid
                                    : companyMasterMap.get(
                                        roleMasterForm.sid
                                    )?.company_name}
                            </td>
                            <td className="align-middle">
                                {roleMasterForm.id}
                            </td>
                            <td className="align-middle">
                                <Select
                                    isMulti
                                    isDisabled
                                    options={menuMaster}
                                    value={roleMasterForm.allowMenus
                                        .slice(0)
                                        .sort((a, b) =>
                                            a.menu_name.localeCompare(
                                                b.menu_name
                                            )
                                        )}
                                    getOptionLabel={getMenuMasterLabel}
                                    getOptionValue={getMenuMasterValue}
                                />
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </Table>
        </div>
    );
};